/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { ZoomVideoProvider } from './providers/zoomVideoProvider';
import { TwilioVideoProvider } from './providers/twilioVideoProvider';

export enum VideoProviderName {
  TWILIO = 'twilio',
  ZOOM = 'zoom',
}

export type VideoProviderType = ZoomVideoProvider | TwilioVideoProvider;
